<template>
  <div v-html='content' class="toyo">
  </div>
</template>

<script>
// request
import { getPdpaDetail } from '@/api/system/pdpa'

// 辅助函数
export default {
  name: 'pdpacontent',
  data() {
    return {
      content:''
    }
  },
  computed: {
    
  },
  mounted() {
    const pdpaId = this.GetRequest('id')
    const lg = this.GetRequest('language')
    getPdpaDetail({id: pdpaId}).then(({ data }) => {
      if(data.code === 0) {
        if(lg == 'th'){
          this.content = data.data.thContent
        }else if(lg == 'en'){
          this.content = data.data.enContent
        }
      }
    })
  },
  methods: {
    GetRequest(queryName) {
      var index = window.location.href.indexOf('?')
      var len = window.location.href.length
      var query = window.location.href.substring(index+1,len)
      var vars = query.split("&")
      for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=")
          if (pair[0] == queryName) { return pair[1] }
      }
      return null
    }
  }
}
</script>

<style lang='scss' scoped>
.toyo{
  padding: 20px;
  height: 100%;
  width:100%;
  overflow-y: scroll;
  position: fixed;
  top:0;
  left:0;
}
</style>
